import type { AuthAction, AuthState } from './types'
import { AuthActionTypes } from './types'

export const initialAuthState: AuthState = {
  user: null,
  isAuthenticated: false,
  initialized: false,
  loading: true,
  error: null
}

export function authReducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case AuthActionTypes.AUTH_INIT:
      return {
        ...state,
        loading: true,
        error: null
      }
    case AuthActionTypes.AUTH_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        initialized: true,
        loading: false,
        error: null
      }
    case AuthActionTypes.AUTH_LOGOUT:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        initialized: true,
        loading: false,
        error: null
      }
    case AuthActionTypes.AUTH_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case AuthActionTypes.AUTH_LOADING:
      return {
        ...state,
        loading: action.payload
      }
    default:
      return state
  }
}
